import _ from 'lodash'
import { combineReducers } from 'redux'
import { reducers } from '@adc/ui-morpheus'
import { ORGANIZATION } from '../../constants/tableTypes'
import {
  STORE_SELECTED_ORGANIZATION_ROW,
  UPDATE_ORGANIZATION_IN_LIST,
} from '../../constants/actionTypes'

const initialState = {
  content: [],
  total_elements: 0,
}

const organizationReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_ORGANIZATION_IN_LIST: {
      const organizations = initialState
      let result = initialState
      if (
        organizations.total_elements > 0 &&
        organizations.content &&
        organizations.content.length > 0
      ) {
        const matchIndex = _.findIndex(organizations.content, {
          id: action.organization.id,
        })
        if (matchIndex > -1) {
          result = {
            ...state,
            content: [
              ...organizations.content.slice(0, matchIndex),
              action.organization,
              ...organizations.content.slice(matchIndex + 1),
            ],
          }
        }
      }
      return result
    }
    case STORE_SELECTED_ORGANIZATION_ROW:
      return {
        ...state,
        content: action.rowData[action.rowIndex],
      }
    default:
      return reducers.dataTable.tableFetchReducer(ORGANIZATION, state, action)
  }
}

export default combineReducers({
  data: organizationReducer,
})

export { initialState, organizationReducer }
